import React from 'react';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import PropTypes from 'prop-types';

const Items = (props) => {
    const item = props.item ? props.item : false;
    const {nameGrid, positionGrid} = props;
    if(!item.title || !item.description) return ''

    let imageResponsive = {
        840: item.image_mobile.url ? item.image_mobile.url : '',
        1440: item.imagen.url ? item.imagen.url : ''
    };
    
    const interaction = () => {
        TagManagerService.interaction('Ver más', 'Destacados con botón administrable ' + positionGrid + ' - ' + nameGrid, item.title);
    }
    
    return (
        <>{
            <div className="featured-with-button-item">
                <Link to={item.url} target={item.url_target} className="featured-with-button-item-image"><ImageLoad srcSet={imageResponsive} src={item.imagen.url ? item.imagen.url : ''}/></Link>
                <span className="featured-with-button-item-title">{item.title}</span>
                <p className="featured-with-button-item-description">{item.description}</p>
                {item.url && <Link to={item.url} target={item.url_target} className={"featured-with-button-item-btn-wrap"} onClick={interaction}><button className="primary-btn featured-with-button-item-btn">Ver más</button></Link>}
            </div>
        }</>
    )
}

Items.propTypes = {
    item: PropTypes.object,
    positionGrid: PropTypes.number,
    nameGrid: PropTypes.string
}

export default Items;
